
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insight/[slug]",
      function () {
        return require("private-next-pages/insight/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insight/[slug]"])
      });
    }
  